export function isE2EUser(userEmail: string) {
  return userEmail.includes('+e2e');
}
